<template>
  <v-main class="core-view-auth">
    <div>
      <router-view :key="$route.path" />
    </div>
  </v-main>
</template>

<script>


export default {
  mounted(){
    document.addEventListener('tidioChat-ready', this.onTidioChatHide);
  },
  beforeDestroy() {
    window.removeEventListener("tidioChat-ready", this.onTidioChatHide);
  },
  method: {
    onTidioChatHide(){
      if(window.tidioChatApi) {
        window.tidioChatApi.display(false);
      }
    }
  }
}
</script>

<style lang="scss">

</style>
